import React from 'react';
import {Typography} from '@mui/material';

const PageTitle = props => {
    return <Typography 
                variant="pageTitle" 
                component="h1" 
                sx={{
                    textAlign: "center",
                    lineHeight: 3,
                    backgroundColor: '#023692',
                    color: 'white',
                    marginBottom: 0
                    }}
                >
                    {props.title}
                </Typography>
}

export default PageTitle;